import { render, staticRenderFns } from "./StoreListSection.vue?vue&type=template&id=5654dae0&scoped=true&"
import script from "./StoreListSection.vue?vue&type=script&lang=js&"
export * from "./StoreListSection.vue?vue&type=script&lang=js&"
import style0 from "./StoreListSection.vue?vue&type=style&index=0&id=5654dae0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5654dae0",
  null
  
)

export default component.exports